import { Link } from "react-router-dom";

const C = {
  ink: "#111827",
  body: "#374151",
  sub: "#6B7280",
  line: "#E5E7EB",
  greenDark: "#047857",
  greenBg: "#ECFDF5",
  greenBorder: "#A7F3D0",
  amber50: "#FFFBEB",
  amber800: "#92400E",
  blue50: "#EFF6FF",
  blue700: "#1D4ED8",
};

const CATEGORY_EMOJI = {
  "트랙터": "🚜",
  "이앙기": "🌾",
  "콤바인": "🌾",
  "전기": "⚡",
  "엔진": "⚙️",
  "배터리": "🔋",
  "유압": "🛢️",
  "농약기": "🌱",
  "기타": "🔧",
  "전체선택": "📦",
};

function relativeTime(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "방금 전";
  if (diff < 3600) return `${Math.floor(diff / 60)}분 전`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}시간 전`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}일 전`;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}.${mm}.${dd}`;
}

function StatusChip({ status }) {
  const isDone = String(status) === "1";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "5px 12px",
        borderRadius: 9999,
        fontSize: 12,
        fontWeight: 700,
        background: isDone ? C.greenBg : C.amber50,
        color: isDone ? C.greenDark : C.amber800,
        border: `1px solid ${isDone ? C.greenBorder : "#FDE68A"}`,
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: 9999,
          background: isDone ? C.greenDark : C.amber800,
        }}
      />
      {isDone ? "답변 완료" : "답변 대기"}
    </span>
  );
}

export default function InquiryCard({ inquiryData }) {
  const emoji = CATEGORY_EMOJI[inquiryData?.type] || "💬";

  return (
    <Link
      to={`/inquiry/${inquiryData.docId}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div
        style={{
          display: "flex",
          gap: 16,
          padding: 18,
          background: "#fff",
          border: `1px solid ${C.line}`,
          borderRadius: 14,
          cursor: "pointer",
          transition: "transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.borderColor = C.greenBorder;
          e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.04)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "";
          e.currentTarget.style.borderColor = C.line;
          e.currentTarget.style.boxShadow = "";
        }}
      >
        <div
          style={{
            width: 60,
            height: 60,
            flexShrink: 0,
            borderRadius: 12,
            background: C.greenBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 30,
          }}
        >
          {emoji}
        </div>
        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 6 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {inquiryData?.type && (
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: C.blue700,
                  background: C.blue50,
                  padding: "2px 8px",
                  borderRadius: 6,
                }}
              >
                {inquiryData.type}
              </span>
            )}
            <StatusChip status={inquiryData?.status} />
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: C.ink,
              letterSpacing: "-0.01em",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {inquiryData?.title || "제목 없음"}
          </div>
          <div
            style={{
              fontSize: 13,
              color: C.body,
              lineHeight: 1.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
            }}
          >
            {inquiryData?.body}
          </div>
          <div style={{ fontSize: 12, color: C.sub }}>
            {relativeTime(inquiryData?.createDate)}
          </div>
        </div>
      </div>
    </Link>
  );
}
